<template><!--隐私协议-->
  <div class="privacy">

    <div style="text-align: center; margin: 20px 0;">
      <h2>隐私协议</h2>

      <br/>
      <span>更新时期：2025年10月22日</span>
      <br/>
      <span>生效时期：2025年10月22日</span>
    </div>

    <div>
      睢宁陌撩信息科技有限公司（以下统称“我们”）深知个人信息对您的重要性，并会尽力保护您的个人信息安全可靠，我们致力于维持您对我们的信任，恪守以下原则，保护您的个人信息：权责一致原则，目的明确原则，选择同意原则，最少够用原则，确保安全原则，主体参与原则，公开透明原则等等。同时我们承诺，我们将按业界成熟的安全解决方案，采取相应的安全保护措施来保护您的个人信息。鉴此，我们制定本《陌撩漂流瓶隐私权政策》（下称“本政策
      /本隐私政策”）并提醒您：
      本政策适用于陌撩漂流瓶产品及相关服务。
      需要特别说明的是，本政策不适用于其他第三方向您提供的服务，也不适用于已另行独立设置隐私权政策的产品或服务。
      <b>在注册或使用我们的服务前，请您务必仔细阅读并透彻理解本政策，特别是以粗体/粗体下划线标识的条款，您应重点阅读，在确认充分理解并同意后使用相关产品或服务。您若拒绝本政策，仅能进入访客态进行浏览。为保障软件及服务的安全运行，我们在响应功能点触发时会收集相关设备信息及权限。</b>如对本政策内容有任何疑问、意见或建议，您可以通过我们提供的联系方式联系我们。
      本隐私政策将帮助您了解以下内容：
      <br> ●引言
      <br> ●1、我们如何收集和使用您的个人信息
      <br> ●2、我们如何使用Cookie、同类技术和SDK技术
      <br> ●3、我们如何共享、转让、公开披露您的个人信息
      <br> ●4、我们如何保护您的个人信息
      <br> ●5、您如何管理您的个人信息
      <br> ●6、我们如何处理未成年人的个人信息
      <br> ●7、我们如何存储您的个人信息
      <br> ●8、本隐私政策如何更新
      <br> ●9、如何联系我们

      引言
      陌撩漂流瓶对其收集的用户信息严格保密，并建立健全用户信息保护制度，以便为每一位用户提供可靠、放心的服务：
      <br><b>  1、清晰明确</b>
      <br> 我们将尽可能采用通俗易懂的文字为您阐释隐私政策，以便您能更清晰地了解我们如何保护和处理所收集的您的信息。
      <br><b>  2、保障权益</b>
      <br> 我们将采取充分、合理的措施保障您的隐私权益。
      <br><b>  3、尊重用户</b>
      <br> 我们尊重用户的选择权、知情权等权利的自由行使，允许您管理您的个人信息。
      <br><b>  4、必要安全</b>
      <br> 我们将仅收取必要的信息，并利用这些信息为您提供安全、详实的服务。
      <br><b>  5、及时贴心</b>
      <br> 我们将随时聆听您的询问，并尽快为您解答您的疑问。
      <br> 为更好的说明，本政策中的下列概念是指：
      <br> <b>个人常用设备信息：指包括硬件序列号、设备MAC地址、软件列表、唯一设备识别码（如IMEI/android
      ID/ICCID/MEID/IDFA/OPENUDID/GUID、SIM卡IMSI信息等）、IP等在内的描述个人常用设备基本情况的信息。
      个人位置信息：指包括精准定位信息、经纬度等。</b>
    </div>

    <h3> 1、我们如何收集和使用您的个人信息</h3>
    <div>
      <div>
        个人信息是指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息，包括姓名、出生日期、身份证件号码、个人生物识别信息、住址、通信联系方式、通信记录和内容、账号密码、财产信息、征信信息、行踪轨迹、住宿信息、健康生理信息、交易信息等。
        个人敏感信息是指一旦泄露、非法提供或滥用可能危害人身和财产安全，极易导致个人名誉、身心健康受到损害或歧视性待遇等的个人信息，包括身份证件号码、个人生物识别信息、银行账号、通信记录和内容、财产信息、征信信息、行踪轨迹、住宿信息、健康生理信息、交易信息、14周岁以下（含）儿童的个人信息等（我们将在本隐私权政策中对具体个人敏感信息以粗体进行显著标识）。
        个人信息以及个人敏感信息包含的内容均出自于GB/T35273《个人信息安全规范》。
        <br> 您理解并同意：
        <br>
        1、我们致力于打造多样的产品和服务以满足您的需求。因我们向您提供的产品和服务种类众多，且不同用户选择使用的具体产品/服务范围存在差异，相应的，收集使用的个人信息类型、范围等会有所区别，请以具体的产品/服务功能为准；
        <br>
        2、我们可能将通过某些功能所收集的信息用于我们的其他服务。例如，我们可能将你在使用我们某一功能或服务时我们收集的信息，在另一功能或服务中用于向你提供特定内容，包括展示对你阅读过的内容进行信息安全类提示、基于特征标签进行间接人群画像并提供更加精准和个性化的服务和内容等。如我们使用您的个人信息，超出了与收集时所声称的目的及具有直接或合理关联的范围，我们将在使用您的个人信息前，再次向您告知并征得您的明示同意。
        <br>
        3、为给您带来更好的产品和服务体验，我们在持续努力改进我们的技术，随之我们可能会不时推出新的或优化后的功能，可能需要收集、使用新的个人信息或变更个人信息使用目的或方式。对此，我们将通过更新本政策、弹窗、页面提示等方式另行向您说明对应信息的收集目的、范围及使用方式，并为您提供自主选择同意的方式，且在征得您明示同意后收集、使用。在此过程中，如果您有任何疑问、意见或建议的，您可通过我们提供的各种联系方式与我们联系，我们会尽快为您作出解答
        特别提示，我们提供用户推荐的服务，您在个人信息中填写的昵称、年龄、性别、星座、行业、工作领域、公司、家乡、经常出没地、个性签名以及上传的头像、照片、公开动态等信息可能会被其他用户分享、推荐至站内或其他软件。
      </div>

      <h4> 收集个人信息的业务功能以及收集的个人信息</h4>
      <div>
        根据《常见类型移动互联网应用程序必要个人信息范围规定》，陌撩漂流瓶App属于“即时通信类”App，即时通信类APP的基本功能服务为“提供文字、图片、语音等网络即时通信服务”，必要个人信息包括：1．注册用户移动电话号码；2．账号信息：账号、即时通信联系人账号列表。另外，基于陌撩漂流瓶的主要服务“推荐交友/附近”，还需要用户提供年龄、性别信息。
        我们所提供产品或服务的功能分别收集的个人信息类型，以及收集、使用个人信息的规则（例如收集和使用个人信息的目的、方式）如下：
        <p>
          <b>1.业务功能：注册成为用户。当您注册陌撩漂流瓶服务时，为完成创建账号，您需要提供以下信息：手机号码或微信授权、昵称、年龄、性别、个人照片（用做头像）、剪切板验证码信息（用于便捷完成验证码输入），收集这些信息是为了帮助你完成陌撩漂流瓶账户注册和使用社交功能。</b>
          我们会根据您在安装、访问及使用“陌撩漂流瓶”软件及相关服务的过程中或软件在后台运行时授予的具体权限收集您所使用的<b>设备相关信息，包括设备型号、操作系统版本、设置参数、设备配置、设备标识（IMEI/Android
          ID/OAID/IDFA/IDFV/MEID/UDID/SIM卡IMSI信息/ICCID/SIM卡状态/VAID/AAID等）、设备序列号、MAC地址、设备网络信息(运营商信息/WIFI信息/WIFI状态/WIFI列表/SSID/BSSID)、设备环境、软件列表/应用列表、运行中的进程信息、SDCard信息、传感器列表等软硬件特征信息）、设备所在位置相关信息（包括您授权的GPS位置以及WLAN接入点、蓝牙和基站等传感器信息）</b>，用于保障软件与服务的安全运行、运营的质量及效率。服务日志信息：当您使用我们的网站或客户端提供的产品或服务时，我们会自动收集您对我们服务的详细使用情况，作为有关服务日志保存。包括您的浏览、点击查看和搜索查询内容、关注分享信息、发布信息，以及IP地址、浏览器的类型、运营商信息、使用的语言、访问日期和时间。
          请注意，单独的设备信息、日志信息等是无法识别特定自然人身份的信息。如果我们将这类信息与其他信息结合用于识别特定自然人身份，或者将其与个人信息结合使用，则在结合使用期间，这类信息将被视为个人信息，除取得您授权或法律法规另有规定外，我们会将该类个人信息做匿名化、去标识化处理。
          <b>手机号码、个人照片属于敏感信息</b>，收集此类信息是为了满足国家法律法规的网络实名制要求以及完成陌撩漂流瓶账号的注册。
          <br> 若您不提供这类信息，您可能无法正常使用我们的服务。
        </p>
        <p>
          <b>2.业务功能：聊天。当您使用聊天服务时，我们没有要求您必须提供的信息。但为了保障您正常使用聊天服务，维护服务的正常运行，改进及优化我们的服务体验并保障您的账号安全，我们会收集和使用您的账号信息。</b>
          <br> 如果您提供以下额外信息，将有助于我们给您提供更好的服务和体验：<b>相册权限、麦克风权限</b>。但如果您不提供这些信息，将不会影响使用本服务的基本业务功能。
        </p>
        <p>
          <b>3.业务功能：首页交友/附近。当您使用推荐交友/附近服务及设置相关筛选项时，为向您推荐附近的用户并将您推荐给其他用户，您需要提供以下信息：个人位置信息。
            <br> 个人位置信息属于敏感信息。</b>
          <br> 若您不提供这类信息，您可能无法正常使用<b>推荐交友/附近</b>的服务。
          <br>
          在使用过程中，如果您提供以下额外信息，将有助于我们给您提供更好的服务和体验：<b>我的照片、昵称、性别、生日、身高、体重、职业、地区、交友目的、我的个性标签</b>（以下简称“个人信息”）。但如果您不提供这些信息，将不会影响使用本服务的基本业务功能。
          <br>
          <b>我的照片、昵称、性别、生日、身高、体重、职业、地区、交友目的、我的个性标签等属于敏感信息。</b>
          <br>
          当您使用推荐交友/附近服务时，我们会根据您的日志信息、标签信息、位置信息、用户个人资料信息、个人筛选设置，向您提供个性化内容推荐服务，并根据您的位置信息与个人筛选设置向您进行排序展示。您可以在陌撩漂流瓶设置中自主控制个性化内容推荐服务的开启和关闭，可选择通过【我-右上角-设置-隐私与权限-个性化推荐】按钮关闭和打开个性化推荐服务，关闭后不会影响您正常使用推荐交友/附近的相关功能。当您选择关闭个性化推荐后，我们将无法为您提供个性化内容服务，我们会基于内容热度等非个性化因素向您展示、推荐内容。
        </p>
        <p>
          <b>4.业务功能：查看圈子。当您使用查看圈子服务时，我们没有要求您必须提供的信息。</b>
          <br> 在使用过程中，如果您提供以下额外信息，将有助于我们给您提供更好的服务和体验：<b>个人位置信息</b>。但如果您不提供这些信息，将不会影响使用本服务的基本业务功能。
          <br> <b>个人位置信息属于敏感信息。</b>
          <br>
          当您查看圈子时，我们会根据您的日志信息、标签信息、位置信息、性别、个人筛选设置以及您的行为信息（即历史浏览、评论、赞、关注信息），向您提供个性化内容推荐服务，并根据您的历史行为信息与圈子内容标签向您进行排序展示。您可以在陌撩漂流瓶设置中自主控制个性化内容推荐服务的开启和关闭，可选择通过【我-右上角-设置-隐私与权限-个性化推荐】按钮关闭和打开个性化推荐服务，关闭后不会影响您正常使用圈子的相关功能。当您选择关闭个性化推荐后，我们将无法为您提供个性化内容服务，我们会基于内容热度等非个性化因素向您展示、推荐内容。
        </p>
        <p>
          <b>5.业务功能：发送圈子。当您使用发送圈子服务时，为提供圈子的素材，您需要提供以下权限、信息：相册权限、摄像头权限。 </b>
          <br> 若您不提供这类信息，您可能无法正常使用 <b>发送圈子 </b>的服务。
          <br> 在使用过程中，如果您提供以下额外信息，将有助于我们给您提供更好的服务和体验：<b>个人位置信息</b>。但如果您不提供这些信息，将不会影响使用本服务的基本业务功能。
          <br> <b>个人位置信息属于敏感信息。 </b>
        </p>
        <p>
          <b>6. 业务功能：匹配。当您使用匹配服务时，为向您推荐附近的已匹配用户，您需要提供以下信息：个人位置信息。
            <br> 个人位置信息属于敏感信息。 </b>
          <br> 若您不提供这类信息，您可能无法正常使用匹配的服务。
        </p>
        <p>
          <b>7.业务功能：真人视频认证。当您使用真人视频认证服务时，您需要提供以下信息：个人生物识别信息中的面部特征信息。
            <br> 个人生物识别信息中的面部特征信息属于敏感信息。 </b>
          <br> 若您不提供这类信息，您可能无法正常使用 <b>真人视频认证 </b>的服务。
          <br> 若您不提供这类信息，您将无法使用 <b>擦肩而过 </b>的服务。
        </p>
        <p>
          <b>8.业务功能：支付功能。支付功能由与我们合作的第三方支付机构向您提供服务，第三方支付机构将会需要收集您的信息，我们将无法获取您的信息。拒绝提供信息仅会使您无法使用上述支付功能，但不影响您使用陌撩漂流瓶的其他功能。 </b>
        </p>
        <p>
          <b>9.业务功能：真人实名认证。在您申请提现或使用其他需实名认证的功能或服务时，为符合法律法规相关要求，保障你或其他用户的安全，或维护功能/服务的安全稳定，需要你提供真实身份信息以完成实名认证。当您选择真人实名认证服务时，为确认您所提供的身份信息为您本人信息且属实，需要您提供以下信息（根据实际业务场景情况可能有所不同）：真实姓名、身份证号及身份证核验授权，个人生物识别信息中的面部特征信息。
            <br>个人生物识别信息中的面部特征信息属于敏感信息 </b>，收集此类信息是为了满足国家法律法规的网络实名制要求，同时保证陌撩漂流瓶产品真实安全的社交氛围。若您不提供这类信息，您可能无法正常使用陌撩漂流瓶认证服务。
        </p>
        <p>
          <b>10.为了让您能够更好的接收消息提醒，我们需要您开启自启动以确保应用处于关闭或后台运行状态下可正常接受客户端推送消息，避免您遗漏消息，因此可能存在通过系统唤醒陌撩漂流瓶的自启动行为，这是保障消息能及时送达所必要的。您可以在手机设置中进行应用自启动管理关闭该权限，但关闭后可能导致您的消息接收延迟。 </b>
          <br> 为了统计投放/推广有效触达率，我们会在注册登录场景通过系统发送广播，获取华为应用市场相关广播信息，这些信息无法与您的真实身份相关联。这些信息将帮助我们分析、衡量相关服务的有效性。
        </p>
        <p>
          <b>11.我们会收集您的传感器信息（陀螺仪、步测器、光线、加速度、磁场、距离、旋转矢量等传感器信息），通过传感器获取设备状态（方向、角度、加速度等）拍摄时调整画面角度帮助您使用正确的角度体验产品或者语音时调整声音播放方式（听筒扬声器转换）为您提供更好的适配效果以及保障账号安全，为您提供安全、可信的产品与使用环境。 </b>
        </p>
        <p>
          12.我们提供的服务可能需要您在您的设备中开启您的<b>位置信息（地理位置）、摄像头（相机）、相册（图片库）、麦克风（语音）、通讯录的访问权限 </b>，以实现这些权限所涉及信息的收集和使用。您可以阅读陌撩漂流瓶设备权限清单，以了解陌撩漂流瓶申请和使用系统权限的情况。相应设备权限并不会默认开启，当涉及重要或敏感的设备权限时，我们会在您使用到相应业务功能时，另行弹窗再次征得您的同意后开启；
          <b>您可在您的设备设置功能中逐项查看上述权限的状态，并可自行决定这些权限随时的开启或关闭。 </b>请您注意，您开启任一权限即代表您授权我们可以收集和使用相关个人信息来为您提供对应服务，您一旦关闭任一权限即代表您取消了授权，我们将不再基于对应权限继续收集和使用相关个人信息，也无法为您提供该权限所对应的服务。但是，您关闭权限的决定不会影响此前基于您的授权所进行的信息收集及使用。
        </p>
        <p>
          <b>13.您知悉并同意，对于您在使用产品及/或服务的过程中提供的联系方式（例如：联系电话），我们在运营中可能会向其中的一种或多种发送多类通知，用于用户消息告知、身份验证、安全验证、用户使用体验调研等；此外，我们也可能会以短信、电话的方式，为您提供您可能感兴趣的服务、功能或活动等商业性信息。但请您放心，如您不愿意接受此类信息，您可以通过手机短信中提供的退订方式进行退订，也可以直接与我们联系进行退订。 </b>
        </p>
        <p>
          <b>14.若你提供的信息中含有其他用户的个人信息，在向陌撩漂流瓶提供这些个人信息之前，您需确保您已经取得合法的授权。</b>
        </p>
        <p>
          <b>15.您提供的信息，将在您使用本服务期间持续授权我们使用。在您注销账号或取消停止使用某项功能时，我们将根据适用法律法规的要求尽快停止使用使其匿名化或删除上述信息。</b>
        </p>
      </div>

      <h4>我们如何使用收集的信息</h4>
      <div>
        我们将按照前述的用途使用您的信息。若我们将信息用于本政策未载明的其他用途，或者将基于特定目的收集而来的信息用于其他目的，或者我们主动从第三方处获取您的个人信息，均会事先获得您的同意。
        <br>
        若我们从第三方处间接获取您的信息的，我们会在收集前明确以书面形式要求该第三方在已依法取得您同意后收集个人信息，并向您告知共享的信息内容，且涉及敏感信息的在提供给我们使用前需经过您的明确确认，要求第三方对个人信息来源的合法性和合规性作出承诺，如第三方有违反行为的，我们会明确要求对方承担相应法律责任；同时，我们的专业安全团队对个人信息会进行安全防护（包括敏感信息分级分类、敏感信息使用的访问控制、敏感信息加密存储等）。我们会使用不低于我们对自身用户个人信息同等的保护手段与措施对间接获取的个人信息进行保护。
        <br> <b>征得授权同意的例外</b>
        <br> 您充分理解并同意，我们在以下情况下收集、使用您的个人信息无需您的授权同意，且我们可能不会同意您提出的更正/修改、删除、注销、撤回同意、索取信息的请求：
        <br> ●1、与我们履行法律法规规定的义务相关的；
        <br> ●2、与国家安全、国防安全有关的；
        <br> ●3、与公共安全、公共卫生、重大公共利益有关的；
        <br> ●4、与犯罪侦查、起诉、审判和判决执行等有关的；
        <br> ●5、出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到您本人同意的；
        <br> ●6、所收集的个人信息是您自行向社会公众公开的；
        <br> ●7、从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道；
        <br> ●8、根据您的要求签订合同所必需的；
        <br> ●9、用于维护所提供的产品或服务的安全稳定运行所必需的，例如发现、处置产品或服务的故障；
        <br> ●10、为合法的新闻报道所必需的；
        <br> ●11、学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的；
        <br> ●12、法律法规规定的其他情形。
        <br>
        请知悉，根据适用的法律，若我们对个人信息采取技术措施和其他必要措施进行处理，使得数据接收方无法重新识别特定个人且不能复原，或我们可能会对收集的信息进行去标识化地研究、统计分析和预测，用于改善陌撩漂流瓶的内容和布局，为商业决策提供产品或服务支撑，以及改进我们的产品和服务（包括使用匿名数据进行机器学习或模型算法训练），则此类处理后数据的使用无需另行向您通知并征得您的同意。
        <br> 如我们停止运营陌撩漂流瓶产品或服务，我们将及时停止继续收集您个人信息的活动，将停止运营的通知以逐一送达或公告的形式通知您，对所持有的个人信息进行删除或匿名化处理。
      </div>

      <h4> 您分享的信息</h4>
      <div>
        您可以通过我们的服务与您的其他用户分享您的相关信息。例如，您在圈子中公开分享的文字和照片。
        <br> <b>请注意，这其中可能包含您的个人身份信息、个人财产信息等敏感信息。请您谨慎考虑披露您的相关个人敏感信息。</b>
        <br> 您可以通过服务中的设置或我们提供的指引删除您公开分享的信息。但请您注意，这些信息仍可能由其他用户或不受我们控制的非关联第三方独立地保存。
      </div>
    </div>

    <h3> 2、我们如何使用Cookie、同类技术和SDK技术</h3>
    <div>
      <h4> Cookie</h4>
      <div>
        为确保网站正常运转、为您获得更轻松的访问体验、向您推荐您可能感兴趣的内容，我们可能会在您的计算机或移动设备上存储名为Cookie的小数据文件。Cookie通常包含标识符、站点名称以及一些号码和字符。借助于
        <br> Cookie，网站能够存储您的偏好等数据。您可以在浏览器中进行相应的数据清除操作。如您进行清除，您可能无法使用由我们提供的、依赖于Cookie的服务或相应功能。
      </div>

      <h4> 其他技术</h4>
      <div>
        除Cookie外，我们还会在网站上使用其他同类技术。我们向您发送的会员短信通知或陌撩漂流瓶小助手站内通知可能含有链接至我们网站内容的地址链接，如果您点击该链接，我们则会跟踪此次点击，帮助我们了解您的产品或服务偏好以便于我们主动改善客户服务体验。如果您不希望自己的活动以这种方式被追踪，则可以随时从我们的寄信名单中退订。
      </div>

      <h4> SDK技术</h4>
      <div>
        SDK技术由与我们合作的第三方机构提供，我们仅能知悉其要求获得授权的权限。第三方机构将会需要收集您的信息，我们无法获取您的信息，除非第三方机构明确向我们披露的要收集的敏感信息。第三方机构要求获得的权限以及明确向我们披露的收集的敏感信息。
        <br> 第三方机构拒绝提供信息仅会使您无法使用第三方机构提供的技术所搭载的功能，但不影响您使用陌撩漂流瓶的其他功能。
        <a @click="goToPath()">详见《第三方SDK权限列表》</a>
      </div>
    </div>

    <h3> 3、我们如何共享、转让、公开披露您的个人信息</h3>
    <div>
      <h4> 共享</h4>
      <div>
        我们不会与陌撩漂流瓶服务提供者以外的公司、组织和个人共享您的个人信息，但以下情况除外：
        <br> 1、在获取明确同意的情况下共享：获得您的明确同意后，我们会与其他方共享您的个人信息；
        <br> 2、在法定情形下的共享：我们可能会根据法律法规规定、诉讼争议解决需要，或按行政、司法机关依法提出的要求，对外共享您的个人信息；
        <br>
        3、与关联公司间共享：<b>为便于我们基于关联账号共同向您提供服务，推荐您可能感兴趣的信息或保护陌撩漂流瓶关联公司或其他用户或公众的人身财产安全免遭侵害，您的个人信息可能会与我们的关联公司共享。</b>我们只会共享必要的个人信息（如为便于您通过陌撩漂流瓶账号使用我们关联公司产品或服务，我们会向关联公司共享您必要的账户信息）且会受本隐私权政策中所声明目的的约束，如果我们共享您的个人敏感信息或关联公司改变个人信息的使用及处理目的，将再次征求您的授权同意；
        <br>
        4、与授权合作伙伴共享：<b>我们可能委托授权合作伙伴为您提供某些服务或代表我们履行职能</b>，我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息，授权合作伙伴只能接触到其履行职责所需信息，且不得将此信息用于其他任何目的。
        <br> 我们将信息发送给支持我们业务的供应商、服务提供商和其他合作伙伴，这些支持包括提供技术基础设施服务、分析我们服务的使用方式和服务的有效性、提供客户服务、支付便利或进行学术研究和调查。
        <br> 对我们与之共享个人信息的公司、组织和个人，我们会与其签署严格的数据保护协定，要求其按照我们的说明、本隐私政策以及其他任何相关的保密和安全措施来处理个人信息。
      </div>

      <h4> 转让</h4>
      <div>
        我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：
        <br> 1、在获取明确同意的情况下转让：获得您的明确同意后，我们会向其他方转让您的个人信息；
        <br> 2、在涉及合并、收购或破产清算情形，或其他涉及合并、收购或破产清算情形时，如涉及到个人信息转让，我们会要求新的持有您个人信息的公司、组织继续受本政策的约束，否则我们将要求该公司、组织和个人重新向您征求授权同意。
      </div>

      <h4> 公开披露</h4>
      <div>
        我们仅会在以下情况，公开披露您的个人信息：
        <br> 1、获得您明确同意或基于您的主动选择，我们可能会公开披露您的个人信息；
        <br>
        2、如果我们确定您出现违反法律法规或严重违反陌撩漂流瓶相关协议规则的情况，或为保护陌撩漂流瓶及其关联公司用户或公众的人身财产安全免遭侵害，我们可能根据法律法规或陌撩漂流瓶相关协议规则征得您同意的情况下披露关于您的个人信息，包括相关违规行为以及陌撩漂流瓶已对您采取的措施。
      </div>

      <h4> 共享、转让、公开披露个人信息时事先征得授权同意的例外</h4>
      <div>
        以下情形中，共享、转让、公开披露您的个人信息无需事先征得您的授权同意：
        <br> 1、与我们履行法律法规规定的义务相关的；
        <br> 2、与国家安全、国防安全直接相关的；
        <br> 3、与公共安全、公共卫生、重大公共利益直接相关的；
        <br> 4、与刑事侦查、起诉、审判和判决执行等直接相关的；
        <br> 5、出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；
        <br> 6、您自行向社会公众公开的个人信息；
        <br> 7、从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。
        <br> 根据法律规定，若我们对个人信息采取技术措施和其他必要措施进行处理，使得数据接收方无法重新识别特定个人且不能复原，则此类处理后数据的共享、转让、公开披露无需另行向您通知并征得您的同意。
      </div>
    </div>

    <h3> 4、我们如何保护您的个人信息</h3>
    <div>
      为了保护您的信息安全，我们将严格遵守法律法规等规范性文件要求的技术措施和操作流程保护您的信息秘密，同时：
      <br> 1.
      我们努力为用户的个人信息提供安全保障，以防止用户个人信息的非法使用、未经授权的访问和披露、泄漏、损坏和丢失。我们将在合理的安全水平内使用各种安全保护措施以保障信息的安全。例如，我们会使用加密技术（例如，SSL）、匿名化处理、加密存储等手段来保护你的个人信息；建立受信赖的保护机制防止个人信息遭到恶意攻击；建立访问控制机制，遵守最小权限原则，确保只有授权人员才可访问个人信息；开展安全和个人信息保护培训课程，加强员工对于保护个人信息保护的认识。
      <br>
      2.我们有行业先进的以数据为核心，围绕数据生命周期进行的数据安全管理体系，从组织建设、制度设计、人员管理、产品技术等方面多维度提升整个系统的安全性。我们建立专门的管理制度、流程和组织以保障个人信息的安全。例如，我们严格限制访问信息的人员范围，要求他们遵守保密义务，并进行审计。若发生个人信息泄露等安全事件，我们会启动应急预案，阻止安全事件扩大，并以推送通知、公告等形式告知您。
      <br> 3.我们会采取合理可行的措施，尽力避免收集无关的个人信息。我们只会在达成本政策所述目的所需的期限内保留您的个人信息，除非需要延长保留期或受到法律的允许。
      <br>
      4.互联网并非绝对安全的环境，<b>我们强烈建议您不要使用非陌撩漂流瓶推荐的通信方式发送个人信息</b>。您可以通过我们的服务建立联系和相互分享。当您通过我们的服务创建交流、交易或分享时，您可以自主选择沟通、交易或分享的对象，作为能够看到您的交易内容、联络方式、交流信息或分享内容等相关信息的第三方。
      <br> 如您发现自己的个人信息尤其是您的账户或密码发生泄露，请您立即联络陌撩漂流瓶客服，以便我们根据您的申请采取相应措施。
      <br>
      请注意，您在使用我们服务时自愿共享甚至公开分享的信息，可能会涉及您或他人的个人信息甚至个人敏感信息，如您在发表动态等公众场合选择上传包含个人信息的图片。请您更加谨慎地考虑，是否在使用我们的服务时共享甚至公开分享相关信息。
      <br> 同时，我们还将按照监管部门要求，上报个人信息安全事件的处置情况。
    </div>

    <h3> 5、您如何管理您的个人信息</h3>
    <div>
      <h4> 个人信息查询</h4>
      <div>
        您有权访问您的个人信息，法律法规规定的例外情况除外。您可以通过以下方式自行访问您的个人信息：
        <br> 账户信息——如果您希望访问或编辑您的账户中的个人信息、设置隐私与权限、设置消息提醒与聊天、更改您的绑定手机号与密码、关闭您的账户等，您可以通过登录账号通过【我-右上角-设置】执行此类操作。
        <br> 个人资料——如果您希望访问或编辑您个人资料中的昵称、头像、家乡、出生年月日、职业、学校、自我介绍以及其他资料，您可以通过登录账户点击【我】进入个人主页，通过点击【个人头像】查看/编辑执行此类操作。
        <br> 动态信息——您可以登录账号通过【圈子】点击自己的头像，或通过点击【我】进入个人主页【我的动态】，访问或清除您的动态发表历史记录。
        <br> 如果您无法通过上述路径访问该等个人信息，您可以随时通过陌撩漂流瓶客服与我们取得联系。我们将在15天内回复您的访问请求。
        <br> 对于您在使用我们的产品或服务过程中产生的其他个人信息，我们将根据相关安排向您提供。
        <br> 您可以通过与陌撩漂流瓶客服联系的方式，申请个人信息副本。
      </div>

      <h4> 个人信息更正</h4>
      <div>
        当您发现我们处理的关于您的个人信息有错误时，您有权要求我们做出更正或补充。您可以通过本条“个人信息查询”中列明的方式提出更正或补充申请。
      </div>

      <h4> 个人信息删除</h4>
      <div>
        您可以通过本条“个人信息查询”中列明的方式删除您的部分个人信息。
        <br> 在以下情形中，您可以向我们提出删除个人信息的请求：
        <br> 1、如果我们处理个人信息的行为违反法律法规；
        <br> 2、如果我们收集、使用您的个人信息，却未征得您的明确同意；
        <br> 3、如果我们处理个人信息的行为严重违反了与您的约定；
        <br> 4、如果您不再使用我们的产品或服务，或您主动注销了账号；
        <br> 5、如果我们永久不再为您提供产品或服务。
        <br> 若我们决定响应您的删除请求，我们还将同时尽可能通知从我们处获得您的个人信息的主体，要求其及时删除，除非法律法规另有规定，或这些主体获得您的独立授权。
        <br> 当您或我们协助您从我们的服务中删除信息后，依据相关法律法规的规定，我们可能不会立即从备份系统中删除相应的信息，我们将安全地存储您的个人信息并将其与任何进一步处理隔离，直到备份可以清除或实现匿名。
      </div>

      <h4> 改变您授权同意的范围</h4>
      <div>
        每个业务功能需要一些基本的个人信息才能得以完成。除此之外，对于额外个人信息的收集和使用，您可以自行或与陌撩漂流瓶客服联系给予或收回您的授权同意。例如：您可以自助取消真实头像认证功能，具体操作步骤为：用户可以在真实头像认证成功后，通过进入个人资料编辑页-点击真实头像认证V标-弹出真实头像认证说明弹窗-点击弹窗下方“取消认证”来取消已认证的真实头像认证。
        <br> 当您收回同意后，我们将不再处理相应的个人信息。<b>但您收回同意的决定，不会影响此前基于您的授权而开展的个人信息处理。</b>
      </div>

      <h4> 用户账号注销</h4>
      <div>
        您可以自行在【注销账户】页面（例如，陌撩漂流瓶手机APP【我-右上角-设置-账户与安全-注销账户】）提交账户注销申请。
        <br> 在您主动注销账户之后，我们将停止为您提供产品或服务，根据相应法律的要求删除您的个人信息，或使其匿名化处理。
      </div>

      <h4> 逝者账号权益</h4>
      <div>
        如陌撩漂流瓶用户不幸去世，逝者未注销的账号将成为纪念账号，我们仍将保护纪念账号中用户个人信息的安全，逝者近亲属可以通过本隐私政策中“如何联系我们”载明的方式联系我们，在不违反逝者生前安排且不侵害他人和公众正当利益的前提下，其可在完成身份核验手续后行使法律法规规定的合法、正当权益。
      </div>

      <h4> 个人信息在个性化推荐、排序与搜索中的应用</h4>
      <div>
        在某些业务功能中，我们可能仅依据信息系统、算法等在内的非人工自动决策机制做出决定。如果这些决定显著影响您的合法权益，您有权要求我们做出解释，我们也将在不侵害陌撩漂流瓶商业秘密或其他用户权益、社会公共利益的前提下提供申诉方法。
        <br>
        个性化推荐：当您使用陌撩漂流瓶推荐交友/附近、浏览动态等推荐内容时，为向您提供更便捷、更符合您个性化需求的信息展示及推送服务，我们可能基于日志信息、标签信息、位置信息、用户行为、用户个人资料信息、个人筛选设置等要素通过计算机算法模型自动计算、综合分析、预测您可能感兴趣的信息内容或功能服务，以进行个性化推荐活动。我们会根据您使用产品过程中的内容浏览等相关行为，对推荐模型进行实时反馈，不断优化推荐结果，更好地向您提供更契合您需求的服务。请您知悉，我们对上述信息进行了去标识化处理，我们使用的个性化推荐算法无法也不会识别特定自然人的真实身份，仅是基于用户行为和特征提供相关性更高与更丰富的信息。
        <br>
        排序精选：为更好的向您展示您喜欢的用户或内容，我们会结合您的地理位置信息、热点排序、标签等相关统计信息，通过计算机算法模型自动计算、综合分析事件个人匹配度，根据个人筛选设置、用户历史行为偏好等进行自动排序，将排序结果在相应位置展示给您。
        <br> 同时，我们通过以下措施帮助您实现对推荐内容的控制及自主决策：
        <br>
        1、如果您不希望被推荐个性化内容，您可以在陌撩漂流瓶设置中自主控制个性化内容推荐服务的开启和关闭，可选择通过【我-右上角-设置-隐私与权限-个性化推荐】按钮关闭或打开个性化推荐服务，关闭后不会影响您正常使用陌撩漂流瓶的相关功能。当您选择关闭个性化推荐后，我们将无法为您提供个性化内容服务，仅会基于内容热度等非个性化因素向您展示、推荐内容。不同服务的个性化推荐服务应用场景、运行机制以及实现控制的方式可能不同，详情请见具体功能的隐私政策相关描述。
      </div>

      <h4> 响应您的上述请求</h4>
      <div>
        为保障安全，您可能需要提供书面请求，或以其他方式证明您的身份。我们可能会先要求您验证自己的身份，然后再处理您的请求。
        <br> 我们将在15天内做出答复。如您对我们的答复不满意，还可以通过陌撩漂流瓶客服发起投诉。
        <br>
        对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情况收取一定成本费用。对于无端重复、需要过多技术手段（例如，需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者非常不切实际的请求，我们可能会予以拒绝。
      </div>

      <h4> 相关限制</h4>
      <div>
        <b>
        在以下情形中，按照法律法规要求，我们将无法响应您的请求：
        <br> 1、与我们履行法律法规规定的义务相关的；
        <br> 2、与国家安全、国防安全直接相关的；
        <br> 3、与公共安全、公共卫生、重大公共利益直接相关的；
        <br> 4、与刑事侦查、起诉、审判和执行判决等直接相关的；
        <br> 5、有充分证据表明您存在主观恶意或滥用权利的；
        <br> 6、出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；
        <br> 7、响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的；
        <br> 8、涉及商业秘密的。
        </b>
      </div>
    </div>

    <h3> 6、我们如何处理未成年人的个人信息</h3>
    <div>
      <b>本软件禁止未成年人注册、使用。</b>
      <br>
      您理解并承诺，您向我们提供的注册信息是真实的，如果通过未成年保护相关机制识别出您的账号具有未成年使用风险，我们将为您提供青少年保护服务模式。如您认为自己不是未成年人，请您申诉进行实名认证，认证通过后，我们将您的账号立即恢复至原使用状态。
      <br> 如您发现我们收集了被监护的未成年个人信息，请立即联系我们，我们核实后会尽快删除相关信息。
    </div>

    <h3> 7、我们如何存储您的个人信息</h3>
    <div>
      我们在中华人民共和国境内运营中收集和产生的您的个人信息，存储在中国境内。
      <br> <b>一般而言，我们自您使用服务时获取到您个人信息之日起至您注销账户后6个月内会存储并保留您的个人信息。</b>
      <br> <b>在您的个人信息超出保留期间后，我们会根据适用法律的要求删除您的个人信息，或使其匿名化处理。</b>
      <br> 当我们的产品或服务发生停止运营的情形时，我们将以推送通知、公告等形式通知您，并在合理的期限内删除您的个人信息或进行匿名化处理。
    </div>

    <h3> 8、本隐私政策如何更新</h3>
    <div>
      我们的隐私政策可能变更。
      <br> 未经您明确同意，我们不会限制您按照本隐私政策所应享有的权利。对于重大变更，我们会提供显著的通知（包括我们会通过陌撩漂流瓶公示的方式进行通知，甚至向您提供弹窗提示）。您也可以定期查看本隐私政策，以获取最新的条款。
      <br> 本政策所指的重大变更包括但不限于：
      <br> 1、我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等；
      <br> 2、我们在控制权等方面发生重大变化。如并购重组等引起的所有者变更等；
      <br> 3、个人信息共享、转让或公开披露的主要对象发生变化；
      <br> 4、您参与个人信息处理方面的权利及其行使方式发生重大变化；
      <br> 5、我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化时；
      <br> 6、个人信息安全影响评估报告表明存在高风险时。
      <br> 如果您在接到通知后，选择继续使用我们的服务，即表示同意受经修订的政策约束。您若拒绝更新后的政策，仅能进入访客态进行浏览。
      <br> 我们还会将本政策的旧版本存档，供您查阅，您可通过前述的联系方式向我们申请查阅。
    </div>

    <h3> 9、如何联系我们</h3>
    <div>
      您可以通过以下方式与我们联系，我们将在15天内回复您的请求：
      <br> 1、如对本政策内容有任何疑问、意见或建议，您可在陌撩漂流瓶APP中通过陌撩漂流瓶小助手与我们联系，或者向我们的服务邮箱moliaos@163.com发送邮件；
      <br> 2、如发现个人信息可能被泄露，您可以发邮件至moliaos@163.com投诉举报；
      <br> 3、我们的注册地址与常用办公地址为江苏省连云港市连云区中华西路48号1115室，个人信息保护相关负责人的联系方式为moliaos@163.com。
      <br> 如果您对我们的回复不满意，特别是您认为我们的个人信息处理行为损害了您的合法权益，
      <b>您还可以通过向被告住所地有管辖权的法院提起诉讼来寻求解决方案。</b>
    </div>

    <br>
    <br>
    <br>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  methods: {
    //  跳转路由
    goToPath() {
      this.$router.push({path: '/terms/privacySDK'});
    },
    goToPathList() {
      this.$router.push({path: '/terms/privacyList'});
    },
  },
  created() {
  }
}
</script>

<style>

.privacy {
  width: 92%;
  max-width: 960px;
  margin: auto;
  font-size: 14px;
  line-height: 26px;
}

.privacy div {
  margin-bottom: 8px;
}

.privacy h3 {
  margin: 8px 0;
}

.privacy h4 {
  margin: 2px 0;
}

p {
  margin: 4px 0;
}

</style>
